import React, { useState, useEffect } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import callLogo from "../../assets/images/call.svg";
import "../additionalservices/AdditionalServices.css";
import safariLogo from "../../assets/images/safari.svg";
import { useNavigate, useLocation } from "react-router-dom";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import emailLogo from "../../assets/images/email-finance.svg";
import headerLogo from "../../assets/images/MyFriendNewsLogo.svg";
import addButton from "../../assets/images/AddIconAdditionalServices.svg";
import editButton from "../../assets/images/EditIconAdditionalServices.svg";
import deleteButton from "../../assets/images/DeleteIconAdditionalServices.svg";
import shopify from "../../assets/images/logo-spotify.svg";
import {
  notification,
  Card,
  Row,
  Col,
  Modal,
  Button,
  Form,
  Select,
  Input,
} from "antd";
import goBackButton from "../../assets/images/GoBackButtonAdditionalServices.svg";
import {
  addFinanceService,
  delFinanceService,
  getFinanceService,
  getFinanceOptions,
} from "../../api/AdditionalServices";

const { Option } = Select;

const Finance = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [subtype, setSubtype] = useState("");
  const [company, setCompany] = useState("");
  const [loading, setLoading] = useState(true);
  const [accounts, setAccounts] = useState([]);
  const [insurance, setInsurance] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const { backgroundColor, message } = location.state;
  const [isEditMode, setIsEditMode] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [subtypeOptions, setSubtypeOptions] = useState([]);
  const [editingSection, setEditingSection] = useState("");
  const [wealthManagement, setWealthManagement] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const [financeOptions, setFinanceOptions] = useState({
    Accounts: { companies: [], subtypes: [] },
    Insurance: { companies: [], subtypes: [] },
    Wealth: { companies: [], subtypes: [] },
  });

  useEffect(() => {
    const fetchFinanceOptions = async () => {
      try {
        const response = await getFinanceOptions();
        const options = {
          Accounts: {
            companies:
              response.data.find((item) => item.type_of_finance === "Accounts")
                ?.company_name || [],
            subtypes:
              response.data.find((item) => item.type_of_finance === "Accounts")
                ?.subtype_of_finance || [],
          },
          Insurance: {
            companies:
              response.data.find((item) => item.type_of_finance === "Insurance")
                ?.company_name || [],
            subtypes:
              response.data.find((item) => item.type_of_finance === "Insurance")
                ?.subtype_of_finance || [],
          },
          Wealth: {
            companies:
              response.data.find((item) => item.type_of_finance === "Wealth")
                ?.company_name || [],
            subtypes:
              response.data.find((item) => item.type_of_finance === "Wealth")
                ?.subtype_of_finance || [],
          },
        };
        setFinanceOptions(options);
      } catch (error) {
        console.error("Error fetching finance options:", error);
        notification.error({
          message: "Error",
          description: error.error || "Failed to fetch finance options",
          duration: 8,
        });
      }
    };

    fetchFinanceOptions();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFinanceService();
        setAccounts(response.data.categorized_services.Accounts);
        setInsurance(response.data.categorized_services.Insurance);
        setWealthManagement(response.data.categorized_services.Wealth);
      } catch (error) {
        console.error("Error fetching data:", error);
        notification.error({
          message: "Error",
          description: error.error || "Failed to fetch finance services",
          duration: 8,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [refreshData]);

  const handleOk = async () => {
    try {
      const data = await form.validateFields();
      const selectedCompany = financeOptions[modalTitle].companies.find(
        (company) => company.name === data.company_name
      );
      const response = await addFinanceService({
        type_of_finance: modalTitle,
        company_name: data.company_name,
        subtype_of_finance: data.subtype_of_finance,
        url: data.url,
        imageUrl: selectedCompany?.imageUrl || shopify,
      });

      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 8,
      });
      setIsModalOpen(false);
      form.resetFields();
      setRefreshData((prev) => !prev);
    } catch (error) {
      console.error("Error adding finance service:", error);
      notification.error({
        message: "Error",
        description:
          error.error || "An unexpected error occurred. Please try again.",
        duration: 8,
      });
    }
  };

  const renderCompanySelect = () => (
    <Form.Item name="company_name" label="Company Name" required>
      <Select
        value={company}
        onChange={handleCompanyChange}
        showSearch
        placeholder="Select or enter company name"
        onSearch={handleAddOption}
        filterOption={(input, option) =>
          option.children.toLowerCase().includes(input.toLowerCase())
        }
        className="dropdown-styling-modal"
      >
        {companyOptions.map((company) => (
          <Option key={company.value} value={company.value}>
            {company.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );

  const handleDeleteConfirm = async () => {
    if (itemToDelete) {
      try {
        const response = await delFinanceService({
          type_of_finance: itemToDelete.section,
          company_name: itemToDelete.company_name,
          subtype_of_finance: itemToDelete.subtype_of_finance,
          url: itemToDelete.url,
        });
        notification.success({
          message: "Deleted",
          description: response.data.message,
          duration: 8,
        });
        setRefreshData((prev) => !prev);
        setIsEditMode(false);
      } catch (error) {
        console.error("Error deleting finance service:", error);
        notification.error({
          message: "Error",
          description:
            error.error || "An unexpected error occurred. Please try again.",
          duration: 8,
        });
      }
    }
    setDeleteModalVisible(false);
    setItemToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setItemToDelete(null);
    setIsEditMode(false);
  };

  const handleDeleteClick = (e, section, item) => {
    e.stopPropagation();
    setItemToDelete({ section, ...item });
    setDeleteModalVisible(true);
  };

  const handleAddButtonClick = (title) => {
    setModalTitle(title);
    const options = financeOptions[title];
    const companyNames = options.companies.map((company) => ({
      label: company.name,
      value: company.name,
      imageUrl: company.imageUrl,
    }));
    setCompanyOptions(companyNames);
    setSubtypeOptions(options.subtypes);
    setIsModalOpen(true);
  };

  const handleEditButton = (section) => {
    setEditingSection(section);
    setIsEditMode(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleGoBackButton = () => {
    navigate("/landing-page");
  };

  const handleSubtypeChange = (value) => {
    setSubtype(value);
  };

  const handleCompanyChange = (value) => {
    setCompany(value);
  };
   const handleAddOption = (inputValue) => {
    if (
      inputValue &&
      !companyOptions.some((option) => option.value === inputValue)
    ) {
      const newOption = {
        value: inputValue,
        label: inputValue,
        imageUrl: shopify, // Default image for new entries
      };
      setCompanyOptions((prevOptions) => [...prevOptions, newOption]);
      setCompany(inputValue); // Set the newly added option as the selected value
    }
  };

  const handleSearch = (input, setOptions, currentOptions) => {
        if (input && !currentOptions.includes(input)) {
            setOptions([...currentOptions, input]);
        }
    };

  const handleCardClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const renderCards = (items, title, section) => {
    return (
      <>
        <Row className="button-title-container">
          <Col>
            <h2 className="title-styling">{title}</h2>
          </Col>
          <Col className="buttons-gap">
            <button
              onClick={() => handleAddButtonClick(section)}
              className="button-styling-finance-services"
            >
              <img src={addButton} alt="Add Button" />
            </button>
            <button
              onClick={() => handleEditButton(section)}
              className="button-styling-finance-services"
            >
              <img src={editButton} alt="Edit Button" />
            </button>
          </Col>
        </Row>

        <div style={{ marginTop: "5px" }}>
          {items.map((item, index) => (
            <Row gutter={[0, 16]} key={index}>
              <Col span={24}>
                <Card
                  className="card-custom-finance-items"
                  onClick={() => handleCardClick(item.url)}
                >
                  <Card.Grid style={{ width: "100%", position: "relative" }}>
                    <div className="card-grid-container">
                      <div className="card-grid-inner">
                        <img
                          src={item.imageUrl}
                          alt={`${item.company_name} Logo`}
                          className="bank-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = shopify;
                          }}
                        />
                        <div>
                          <strong className="company-name">
                            {item.company_name}
                          </strong>
                          <strong className="subtype-of-finance">
                            {item.subtype_of_finance}
                          </strong>
                        </div>
                      </div>
                      {section === "Insurance" && (
                        <div className="logo-container">
                          <img
                            src={callLogo}
                            alt="Call Logo"
                            className="insurance-logo-image"
                          />
                          <img
                            src={emailLogo}
                            alt="Email Logo"
                            className="insurance-logo-image"
                          />
                          <img
                            src={safariLogo}
                            alt="Safari Logo"
                            className="insurance-logo-image"
                          />
                        </div>
                      )}
                    </div>

                    {isEditMode && editingSection === section && (
                      <div className="delete-button-container">
                        <button
                          className="delete-button"
                          onClick={(e) => handleDeleteClick(e, section, item)}
                        >
                          <img src={deleteButton} alt="Delete Button" />
                        </button>
                      </div>
                    )}
                  </Card.Grid>
                </Card>
              </Col>
            </Row>
          ))}
        </div>
      </>
    );
  };

  return (
    <div className="full-height-container">
      <Row className="row-spacing row-justify-xs row-justify-md row-justify-lg">
        <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
          <UserHeader
            setDrawer={openDrawer}
            backgroundColor={backgroundColor}
            headerLogo={headerLogo}
          />
        </Col>
        {isDrawerOpen && (
          <Col span={4}>
            <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
          </Col>
        )}
      </Row>
      <Row
        justify="space-between"
        align="middle"
        className="go-back-button-home"
      >
        <Col>
          <button
            onClick={handleGoBackButton}
            className="button-styling-additonalservices"
          >
            <img src={goBackButton} alt="Go Back Button" />
          </button>
        </Col>
        <Col className="col-center">
          <span className="go-back-message">{message}</span>
        </Col>
      </Row>

      {loading ? (
        <div className="centered-container">
          <ClipLoader
            loading={loading}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        <Row gutter={[16, 16]} className="p-50">
          <Row className="finance-card-styling">
            <Col className="finance-card-column">ACCOUNTS</Col>
            <Col className="finance-card-column">INSURANCE</Col>
            <Col className="finance-card-column">WEALTH MANAGEMENT</Col>
          </Row>
          <Col span={8}>
            {renderCards(accounts, "Current Accounts", "Accounts")}
          </Col>
          <Col span={8}>{renderCards(insurance, "Insurance", "Insurance")}</Col>
          <Col span={8}>
            {renderCards(wealthManagement, "Wealth Management", "Wealth")}
          </Col>
        </Row>
      )}
      <Modal
        className="custom-modal-finance"
        title={`Add ${modalTitle}`}
        open={isModalOpen}
        closable={false}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} layout="vertical" name="financeResourceForm">
          <Form.Item name="subtype_of_finance" label="Type" required>
            <Select
              value={subtype}
              onChange={handleSubtypeChange}
              showSearch
              placeholder="Select or enter subtype"
              onSearch={(input) => handleSearch(input, setSubtypeOptions, subtypeOptions)}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              className="dropdown-styling-modal"
            >
              {subtypeOptions.map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {renderCompanySelect()}

          <Form.Item
            name="url"
            label="URL"
            required
            rules={[
              { required: true, message: "Please input the URL!" },
              { type: "url", message: "Please enter a valid URL!" },
            ]}
          >
            <Input />
          </Form.Item>

          <Button
            key="cancel"
            onClick={handleCancel}
            style={{
              backgroundColor: backgroundColor,
              borderColor: backgroundColor,
              color: "white",
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            style={{
              backgroundColor: backgroundColor,
              borderColor: backgroundColor,
              marginRight: "10px",
              marginTop: "10px",
            }}
            onClick={handleOk}
          >
            Submit
          </Button>
        </Form>
      </Modal>
      <Modal
        title="Confirm Deletion"
        className="custom-modal-finance"
        visible={deleteModalVisible}
        onOk={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        okText="Delete"
        okButtonProps={{ danger: true }}
        bodyStyle={{ padding: "16px" }}
        closable={false}
        footer={[
          <Button
            key="cancel"
            onClick={handleDeleteCancel}
            style={{
              borderColor: "#d3d3d3",
              color: "#000",
              marginRight: "45px",
              width: "400px",
            }}
          >
            No
          </Button>,
          <Button
            key="ok"
            type="primary"
            onClick={handleDeleteConfirm}
            style={{
              backgroundColor: "#A5A7D0",
              borderColor: "#A5A7D0",
              color: "#fff",
              marginTop: "15px",
              marginRight: "45px",
              width: "400px",
            }}
          >
            Delete
          </Button>,
        ]}
      >
        <div style={{ paddingTop: "16px" }}>
          <p>Are you sure you want to delete this finance service?</p>
        </div>
      </Modal>
    </div>
  );
};

export default Finance;
